<template>
  <div class="viaply-verify">

    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>审核授权</el-breadcrumb-item>
      <el-breadcrumb-item>游客申请管理</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">

        <el-form-item  label="审批状态">
          <el-select  size="mini" v-model="currentastates" style="width:120px;" filterable placeholder="授权状态">
                  <el-option
                      v-for="item in authstates"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="dataList"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="idai"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="name"
          label="申请人姓名">
        </el-table-column>
        <el-table-column
          prop="applyemail"
          label="申请人邮箱">
        </el-table-column>
        <el-table-column
          prop="applycop"
          label="申请人机构">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="数据用途">
        </el-table-column>
        <el-table-column
          prop="apply_date"
          label="申请日期"
          width ="150px">
        </el-table-column>
        <el-table-column
          prop="data_id"
          label="数据主键"
          width ="80px"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="ogs_id"
          label="数据ID">
        </el-table-column>
        <el-table-column
          prop="data_type"
          label="数据表"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="auth_code"
          label="授权码"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="authed_date"
          label="审批日期" 
          width ="150px">
        </el-table-column>
        <el-table-column
          prop="sys_validity"
          width="60"
          label="授权有效期"
          align="center"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="end_date"
          label="失效日期"
          width ="150px">
        </el-table-column>
        <el-table-column
          prop="auth_states"
          width="80"
          label="授权状态">
        </el-table-column>
        <el-table-column
          width="120"
          label="操作">
          <!-- <template slot="header" slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="BatchEdit">
              批量修改
            </el-button>
          </template> -->
          <template slot-scope="scope">
            <!-- <el-link type="primary" :href="`/download/${scope.row.idai}`" target="_blank">下载</el-link> -->

            <el-button
              v-show="scope.row.isverok"
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="verok(scope.row)">
              同意
            </el-button>

            <el-button
              v-show="scope.row.isverno"
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="verno(scope.row)">
              拒绝
            </el-button>

          
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {AuthStates} from '../common';
import axios from 'axios';

export default {
  name: 'ViaplyVerify',
  data() {
    return {
      searchParams: {
        proposal: '',
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      checkedisopen:false,
      // checkedisstate:false,
      authstates: AuthStates,
      currentastates: 'all',

      applyIsVisible: false,

      currentDataId: '',
      multipleSelection:[],
    };
  },
  created() {
    this.getData();
  },
  
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    dataList() {
      return this.list.map((item) => {
        let isverok = false;
        let isverno = false;
        // console.log('审批信息代入'+item);
        if (this.userInfo) {
          isverok = item.auth_states === 'apply' || item.auth_states === 'no';
          isverno = item.auth_states === 'apply' || item.auth_states === 'ok' ;
        }
        return {
          ...item,
          isverok,
          isverno,
        }
      });
    },
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        datastatus: this.currentastates,
        dataproc: this.checkedisstate,
        ...this.searchParams,
      }
      axios.post('/iapi/vv', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    BatchEdit(){
      if(this.multipleSelection.length===0){
        alert('请选择数据!')
        return;
      }

    },
    handleSelectionChange(val){
      // console.log('data',val);
      this.multipleSelection = val;
    },
    verok(dataId) {
      // console.log('dasdfdsaf==',dataId);
      const params = dataId;
      axios.post('/iapi/verok', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('同意申请,系统将通过邮件发送下载链接！');
        }
      });
      this.getData();
    },
    verno(dataId) {
      const params = dataId;
      axios.post('/iapi/verno', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('拒绝申请!');
        }
      });
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },

  },
};
</script>

<style scoped>
.viaply-verify {
  padding: 16px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>